import React, { useRef, useEffect, useMemo } from 'react';
import { RelativeDiv, MarginalDiv } from './styles';

const WidthResizableDiv = ({ customId, width, height, resizable, onResizeStop, children, margin, className,
 pageOverflowEnabled, handle = ['e', 'w', 'n', 's'], backgroundColor = 'transparent' }) => {
  const moveableRef = useRef(null);
  const containerRef = useRef(null);
  const frameMap = useRef(new Map());

  const [topMargin, rightMargin, bottomMargin, leftMargin] = margin;

  useEffect(() => {
    if (moveableRef.current) moveableRef.current.updateRect();
    frameMap.current.clear();
  }, [width, height, margin]);

  const WrapperDiv = useMemo(() => pageOverflowEnabled ? RelativeDiv : MarginalDiv, [pageOverflowEnabled]);

  return (
    <>
    <WrapperDiv id={customId} ref={containerRef} className={`blockLayoutContainer`} data-max-height={height}
      style={{ height: 'fit-content', width, minHeight: height, backgroundColor: backgroundColor }}
      leftMargin={leftMargin}
      topMargin={topMargin}
      rightMargin={rightMargin}
      bottomMargin={bottomMargin}
    >
      {children}
    </WrapperDiv>
    </>
  )
}

export default WidthResizableDiv;